/**
 * A Point's week as the admin edits it (ticket 45): one row per ISO weekday — worked
 * or not, its hours, an optional lunch — and the week the server keeps (only the
 * working days, "HH:mm" in Tashkent time). The server checks the rules and names a
 * broken one; these two only translate between the form and the request. Pure.
 */

export interface ScheduleDay {
	day: number
	hours: { from: string; to: string }
	lunch?: { from: string; to: string }
}

export interface DayRow {
	day: number
	on: boolean
	from: string
	to: string
	lunchFrom: string
	lunchTo: string
}

export const WEEKDAYS = [1, 2, 3, 4, 5, 6, 7] as const

/** A day not in the week yet starts from these hours, unticked. */
const DEFAULT_ROW = { from: '09:00', to: '19:00', lunchFrom: '', lunchTo: '' }

/** The form of a week: every weekday, ticked when the Point works it. */
export function weekRowsOf(schedule: readonly ScheduleDay[] | null): DayRow[] {
	return WEEKDAYS.map((day) => {
		const kept = schedule?.find((d) => d.day === day)
		return kept
			? {
					day,
					on: true,
					from: kept.hours.from,
					to: kept.hours.to,
					lunchFrom: kept.lunch?.from ?? '',
					lunchTo: kept.lunch?.to ?? '',
				}
			: { day, on: false, ...DEFAULT_ROW }
	})
}

/** The week to send: the ticked days, a lunch only when both its ends are given. */
export function scheduleOfRows(rows: readonly DayRow[]): ScheduleDay[] {
	return rows
		.filter((r) => r.on)
		.map((r) => ({
			day: r.day,
			hours: { from: r.from.trim(), to: r.to.trim() },
			...(r.lunchFrom.trim() && r.lunchTo.trim()
				? { lunch: { from: r.lunchFrom.trim(), to: r.lunchTo.trim() } }
				: {}),
		}))
}
